"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityViewSource = void 0;
exports.instanceOfEntityViewSource = instanceOfEntityViewSource;
exports.EntityViewSourceFromJSON = EntityViewSourceFromJSON;
exports.EntityViewSourceFromJSONTyped = EntityViewSourceFromJSONTyped;
exports.EntityViewSourceToJSON = EntityViewSourceToJSON;
exports.EntityViewSourceToJSONTyped = EntityViewSourceToJSONTyped;
/**
 *
 * @export
 */
exports.EntityViewSource = {
    DetailsPage: 'details_page',
    MyScheduleCalendar: 'my_schedule_calendar',
    BrowseShiftsList: 'browse_shifts_list'
};
function instanceOfEntityViewSource(value) {
    for (const key in exports.EntityViewSource) {
        if (Object.prototype.hasOwnProperty.call(exports.EntityViewSource, key)) {
            if (exports.EntityViewSource[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function EntityViewSourceFromJSON(json) {
    return EntityViewSourceFromJSONTyped(json, false);
}
function EntityViewSourceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function EntityViewSourceToJSON(value) {
    return value;
}
function EntityViewSourceToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=EntityViewSource.js.map